import { types, actions } from './requests'
export const CREATEWORKER_TYPES = {
    ...types('CREATEWORKER'),
}
export const CREATEWORKER_ACTIONS = {
    ...actions('CREATEWORKER'),
}
